import { Alert, Button, Loader, Skeleton } from '@dreamtree-org/twreact-ui';
import Panel from './Panel';

/**
 * The four states every screen owes the user: loading, empty, error, and a
 * confirmation before anything destructive. Each is a thin composition of
 * twreact-ui primitives so the wording and spacing stay consistent app-wide.
 */

export function LoadingState({ text = 'Loading…', rows = 0 }) {
  if (rows > 0) {
    return (
      <Panel className="p-4">
        <Skeleton count={rows} height={18} gap="0.75rem" />
      </Panel>
    );
  }
  return (
    <div className="flex items-center justify-center py-16">
      <Loader text={text} />
    </div>
  );
}

export function ErrorState({ title = 'Could not load', message, onRetry }) {
  return (
    <Alert variant="error" title={title}>
      <div className="space-y-3">
        <p>{message || 'Something went wrong. Please try again.'}</p>
        {onRetry ? (
          <Button size="sm" variant="outline" onClick={onRetry}>
            Try again
          </Button>
        ) : null}
      </div>
    </Alert>
  );
}

export function EmptyState({ title, message, icon = null, action = null }) {
  return (
    <Panel className="p-10 text-center">
      {icon ? <div className="mx-auto mb-3 w-fit text-primary-400">{icon}</div> : null}
      <h3 className="text-base font-semibold text-[var(--app-text)]">{title}</h3>
      {message ? <p className="mx-auto mt-1 max-w-md text-sm text-[var(--app-muted)]">{message}</p> : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </Panel>
  );
}
